import { Component, Emit, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';

@Component({})
export default class RouteView extends Vue {
  @State(s => s.app.multiTab) multiTab?: boolean;

  render() {
    const {
      $route: { meta },
    } = this;
    const inKeep = (
      <keep-alive>
        <router-view />
      </keep-alive>
    );
    const notKeep = <router-view />;

    if (this.multiTab && (meta === null || (meta.noCache && meta.noCache !== true))) {
      return inKeep;
    }

    return notKeep;
  }
}
